import appApi from '../../../api/app-api';
import { CalendarEvent } from '../../../pages/course/lectures/calendar/big-calendar/course-lecture-event-calendar';
import { CalendarScheduleFlat } from '../../../api/types/calender/calendar-schedule-flat';
import { toast } from 'react-toastify';

const transformToCalendarEvents = (
  schedules: CalendarScheduleFlat[],
): CalendarEvent[] => {
  return schedules.map((schedule, index) => {
    const title =
      `${schedule.courseName} - ` +
      (schedule.scheduleType === 'lecture'
        ? `${schedule.lectureName ?? ''}`
        : `${schedule.examName} (מבחן)`);

    console.log(JSON.stringify(title));

    return {
      title: title,
      start: new Date(schedule.startTime),
      end: new Date(schedule.endTime),
      resourceId: schedule.classId,
    };
  });
};

export const loadCalendarEventsOperations = async (
  branchId: number | undefined,
  year: number,
  month: number,
): Promise<CalendarEvent[]> => {
  try {
    if (!branchId) {
      toast.warn('יש לבחור שולחה');
      throw new Error('No branchId is provided');
    }
    const res = await appApi.getBranchSchedule(branchId, year, month);
    return transformToCalendarEvents(res.data.body);
  } catch (e) {
    console.error(
      `loadCalendarEventsOperations is failed with the error: ${e}`,
    );
    throw e;
  }
};
